module.exports = __webpack_public_path__ + "img/financialperformance-436x218-performancedashboard.fa2d77d9.jpg";